module.exports = __webpack_public_path__ + "static/media/export_products.cdb0bef9.svg";